module.exports = __webpack_public_path__ + "media/images/icons/icn_022-b62915dc42bf5ae20dd462b74a52aa0e.svg";